import React from 'react'
import GroupsDoVd from '../GroupsDoVd'

export default function GroupsDO() {
    return <GroupsDoVd type={0} title="Группы ДО" />
}
